<template>
  <div class="contact-us full-screen bg-light">
    <div class="wrapper wrapper-full-page section content">
      <div class="pt-4">
        <div class="container">
          <div class="row">
            <div class="col-md-8 offset-md-2 text-center">
              <div v-if="loading" class="text-center">
              <h3>Παρακαλώ περιμένετε...</h3>
              </div>
              <div v-else>
                <div v-if="errorMsg || errorMsg !== ''">
                  <h2 class="text-danger"><span class="ti-warning"></span>{{ errorMsg }}</h2>
                </div>
                <div v-else class="col-md-8 offset-md-2 text-center">
                  <h2 class="text-success"><span class="ti-check-box"></span> Ολοκληρώθηκε η αλλαγή ηλεκτρονικής διεύθυνσης</h2>
                  <p class="text-muted mt-4">Μπορείτε να συνδεθείτε στο λογαριασμό σας <router-link :to="{path:'/login'}">εδώ</router-link></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
export default {
  data() {
    return {
      token: this.$route.params.token,
      email: decodeURI(this.$route.params.email),
      errorMsg: "",
      loading: false
    };
  },
  mounted () {
      this.errorMsg = "";
      if (!this.token || this.token === "") {
        this.errorMsg = 'Ο σύνδεσμος έχει λήξει';
        return false;
      }
      if (!this.email || this.email === "") {
        this.errorMsg = 'Ο σύνδεσμος έχει λήξει';
        return false;
      }

      this.loading = true;
      Api.send2("POST", "/user/reset/email", {email: this.email}, this.token)
      .then((response) => {
        this.errorMsg = "";
        this.$router.push({name: 'reset_email_success'})
      })
      .catch((err) => {
        if (err.code === 400) {
          this.errorMsg = err.msg;
        } else {
          this.errorMsg = 'Ο σύνδεσμος έχει λήξει';
        }
      })
      .finally(() => {
        this.loading = false;
      });
    },
};
</script>
<style></style>
